import {
  AffectedStaffEndOfStayReport,
  AffectedStaffEndOfStayReportInput
} from '../../lib/types/models/affectedStaff/affected-staff-end-of-stay-report'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function submitAffectedStaffEndOfStayReport(data: {
  input: AffectedStaffEndOfStayReportInput
  affectedStaffId: number
}) {
  const { affectedStaffId: id, input } = data

  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.submitAffectedStaffEndOfStayReport.url, { id }))
    .post<AffectedStaffEndOfStayReport>(input)
}
